import { FC } from 'react';
import { Tile } from '@carbon/react';
import { format0, formatWholeDollarCurrency } from 'utils/number';
import type { RoyaltyCheckStatistics } from './types';
import styles from './summary-cards.module.scss';

interface Props {
  statistics: RoyaltyCheckStatistics | undefined;
}

interface TileSpec {
  label: string;
  value: string;
}

const RoyaltyChecksSummaryCards: FC<Props> = ({ statistics }) => {
  const provisioned = statistics?.provisioned;
  const tiles: TileSpec[] = [
    { label: 'Total Royalty Checks', value: format0(statistics?.totalRecords) },
    {
      label: 'Total Check Amount',
      value: formatWholeDollarCurrency(statistics?.totalCheckAmount),
    },
    {
      label: 'Average Check Amount',
      value: formatWholeDollarCurrency(statistics?.averageCheckAmount),
    },
    { label: 'Total Properties', value: format0(statistics?.totalProperties) },
    // Provisioned (auto-connected) subset — Epic 3.
    {
      label: 'Provisioned Royalty Checks',
      value: format0(provisioned?.totalRoyaltyChecks),
    },
    {
      label: 'Provisioned Check Amount',
      value: formatWholeDollarCurrency(provisioned?.totalCheckAmount),
    },
    {
      label: 'Provisioned Avg Check Amount',
      value: formatWholeDollarCurrency(provisioned?.averageCheckAmount),
    },
    {
      label: 'Provisioned Properties',
      value: format0(provisioned?.totalProperties),
    },
  ];

  return (
    <div className={styles.summary}>
      {tiles.map((t) => (
        <Tile key={t.label} className={styles.tile}>
          <p className={styles.label}>{t.label}</p>
          <p className={styles.value}>{t.value}</p>
        </Tile>
      ))}
    </div>
  );
};

export { RoyaltyChecksSummaryCards };
